import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow, { tableRowClasses } from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import Checkbox from "@mui/material/Checkbox";
import { visuallyHidden } from "@mui/utils";
import { ReactComponent as SortIcon} from '../../../assets/images/uparrow.svg'
import styled from "@emotion/styled";
import { Link, createSearchParams, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { RECOMMENDATIONS_ENDPOINT } from "../../../routes/route";
import { CircularProgress, TablePagination, tablePaginationClasses } from "@mui/material";
import { ReactComponent as arrowDownIcon} from '../../../assets/images/arrow-down-brown.svg'
import * as routes from '../../../routes/route'
import moment from "moment";



const TableRowStyled = styled(TableRow)`
     
  // &:nth-of-type(odd) td {
  //   border: none;
  //   padding-bottom: 0;
  // },

  // &:nth-of-type(4n-1) td {
  //   border-top: 2.5px solid #DDDDDD;
  //   background-color: #F1F1F1;
  // },

  // // &:nth-of-type(4n-0) td {
  // //   border-bottom: 2.5px solid #DDDDDD;
  // //   background-color: #F1F1F1;
  // // },

  // &:nth-of-type(4n-1) td:first-of-type, &:nth-of-type(4n-0) td:first-of-type  {
  //   border-left: 2px solid #DDDDDD;
  // },

  // &:nth-of-type(4n-1) td:last-child, &:nth-of-type(4n-0) td:last-child  {
  //   border-right: 2px solid #DDDDDD;
  // },
`;

const TableCellStyled = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontWeight: 550,
    fontFamily: 'Montserrat',
    zIndex: 0,
    color: "#AAAAAA",
    padding: '5px 8px 5px 5px',
    wordBreak: "break-word",
    fontSize: "13px",
    textTransform: 'uppercase',
    borderTop: "1px solid #DDDDDD"
  },
  

  [`&.${tableCellClasses.head}:first-of-type`]: {
    // borderLeft: '0.5px solid #74613C',
    padding: '18px 8px 18px 15px',
  },

  [`&.${tableCellClasses.head}:last-child`]: {
    // borderRight: '0.5px solid #74613C'
  },
  
  [`&.${tableCellClasses.body}`]: {
    fontSize: "14px",
    padding: '8px',
    wordBreak: "break-word",
    fontSize: "14px",
  },

  [`&.${tableCellClasses.body}:first-of-type`]: {
    textTransform: 'capitalize',
    padding: '8px',
  },
}));

const TablePaginationStyled = styled(TablePagination)(({ theme }) => ({
  fontSize: '14px',

  [`& .${tablePaginationClasses.select}`]: {
    padding: '4px 8px',
    borderRadius: '8px',
    backgroundColor: '#F5F3EC',
    border: '1px solid #DDDDDD'
  },

  [`& .${tablePaginationClasses.select}, & .${tablePaginationClasses.select}:focus`]: {
    borderRadius: '8px',
    border: '1px solid #DDDDDD'
  },

  [`& .${tablePaginationClasses.selectIcon}`]: {
    top: '12px',
    right: '7px',
    width: '9px'
  },

  [`& .${tablePaginationClasses.selectLabel}, &  .${tablePaginationClasses.displayedRows}`]: {
    margin: '0',
    fontSize: '14px'
  },

  [`& .${tablePaginationClasses.actions} button`]: {
    backgroundColor: '#F5F3EC',
    marginRight: '5px',
    padding: '3px 5px',
    border: '1px solid #DDDDDD'

  },

  [`& .${tablePaginationClasses.actions} svg`]: {
    width: '20px'
  },

}));

const RecommendationsTable = ({
  loading,
  data,
  columns,
  checkbox = true,
  pagination = true,
  filter,

  //props are required if pagination is true
  totalCount,
  totalPages,
  start,
  end,
  currentPage,
  rowsPerPage,
  getTableData
}) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const navigate = useNavigate();
  const [order, setOrder] = useState(filter.order);
  const [orderBy, setOrderBy] = useState(filter.orderBy);

  const [selected, setSelected] = useState([]);
  const dispatch = useDispatch()


  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    let newOrder = isAsc ? "desc" : "asc";
    setOrder(newOrder);
    setOrderBy(property);
    
    searchParams.delete("order")
    searchParams.delete("orderBy")

      let newPair= [["order", newOrder], ["orderBy", property]];

      navigate({
        pathname: `${routes.RECOMMENDATIONS_ENDPOINT}`,
        search: `?${createSearchParams([...searchParams.entries(), ...newPair])}`,
      }, {replace: true})
  };

  const handleSelectAllClick = (event) => {
    const newSelected = event.target.checked ? data?.map((item) => ({subscriberId: item.subscriberId, flatId: item.flatId})) : [];
    setSelected(newSelected);
  };

  const handleClick = (event, id, flatId) => {
    const newSelected = selected.some(item => item.subscriberId === id && item.flatId === flatId)
      ? selected.filter((selectedItem) => !(selectedItem.subscriberId === id && selectedItem.flatId === flatId))
      : [...selected, {subscriberId: id, flatId}];
    setSelected(newSelected);
  };

  const handleChangePage = (e, newPage) => {
    window.scrollTo(0, 0)
      searchParams.delete("page")
      navigate({
        pathname: `${RECOMMENDATIONS_ENDPOINT}`,
        search: `?${createSearchParams([...searchParams.entries(), ["page", newPage]])}`,
      })
  };

  const handleChangeRowsPerPage = (e) => {
    window.scrollTo(0, 0)
    let value=parseInt(e.target.value, 10);
    if (rowsPerPage !== value) {
      searchParams.delete("pageLimit")
      searchParams.delete("page")
      navigate({
        pathname: `${RECOMMENDATIONS_ENDPOINT}`,
        search: `?${createSearchParams([...searchParams.entries(), ["pageLimit", value]])}`,
      })
    }
  };

  const isSelected = (id, flatId) => selected.some(item => item.subscriberId === id && item.flatId === flatId);


  useEffect(()=>{      
    setSelected([])
  }, [searchParams])

  useEffect(()=>{
    setOrder(filter.order)
    setOrderBy(filter.orderBy)
  }, [filter])

  return (
    <Box
      sx={{ width: "100%", fontSize: "13px", paddingBottom: '10px', height: data.length ? 'calc(100% - 95px)' : 'fit-content'}}
      className="status-report-table-component ps-1"
    >
      <TableContainer 
        style={{
          height: data.length ? 'calc(100% - 40px)' : 'fit-content'
        }}     >
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {!!checkbox && (
                <TableCellStyled size="small" sx={{pl:'0 !important', pr: 2, width: 36 }}>
                  <Checkbox
                    size="small"
                    indeterminate={false}
                    checked={data?.length > 0 && selected?.length === data?.length}
                    onChange={handleSelectAllClick}
                    inputProps={{
                      "aria-label": "select all",
                    }}
                    sx={{
                      p: 0,
                      color: "#AAAAA",
                      "&.Mui-checked": {
                        color: "#CF001C",
                      },
                    }}
                    disabled={loading || !data}
                  />
                </TableCellStyled>
              )}
              {columns?.map((column) => (
                <TableCellStyled
                  size="small"
                  key={column.sortingKey+ 'heading'}
                  align={column.numeric ? "right" : "left"}
                  sortDirection={orderBy === column.sortingKey ? order : false}
                  sx={{
                    width: column.width || "fit-content",
                    minWidth: column.width || "fit-content",
                  }}
                >
                  <TableSortLabel
                    hideSortIcon={true}
                    active={orderBy === column.sortingKey}
                    direction={orderBy === column.sortingKey ? order : "asc"}
                    onClick={() => {
                      if (column.sort) {
                        handleRequestSort(column.sortingKey);
                      }
                    }}
                    IconComponent={SortIcon}
                    sx={{
                      ".MuiTableSortLabel-icon": {
                        opacity: "1 !important",
                      },
                      svg: {
                        flexShrink: 0,
                      },
                    }}
                  >
                    {column.label}
                    {orderBy === column.sortingKey ? (
                      <Box component="span" sx={visuallyHidden}>
                        {order === "desc"
                          ? "sorted descending"
                          : "sorted ascending"}
                      </Box>
                    ) : null}
                  </TableSortLabel>
                </TableCellStyled>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {
              !loading &&
              <>
                {!!data?.length && data?.map((row, rowIndex) => {
                    const isRowSelected = isSelected(row?.subscriberId, row.flatId);

                    return (
                      <React.Fragment 
                        key={`${rowIndex}`}
                      >
                        <TableRowStyled
                          role="checkbox"
                          aria-checked={isRowSelected}
                          tabIndex={-1}
                          selected={isRowSelected}
                        >
                          {!!checkbox && (
                            <TableCellStyled size="small" sx={{pl:'0 !important', zIndex: 0}} onClick={(event) => handleClick(event, row?.subscriberId, row?.flatId)}>
                              <Checkbox
                                checked={isSelected(row?.subscriberId, row.flatId)}
                                onChange={(e) =>handleClick(e, row?.subscriberId, row?.flatId)}
                                size="small"
                                color="primary"
                                inputProps={{
                                  "aria-labelledby": `generic-table-checkbox-${row?.sortingKey}`,
                                }}
                                sx={{
                                  p: 0,
                                  color: "#AAAAA",
                                  "&.Mui-checked": {
                                    color: "#CF001C",
                                  },
                                }}

                              />
                            </TableCellStyled>
                          )}
                          {/* Serial Number */}
                          <TableCellStyled size="small" align="left" style={{cursor: 'pointer', verticalAlign: 'top'}}>
                            { row.name|| '-'}
                          </TableCellStyled>

                          <TableCellStyled size="small" align="left" sx={{verticalAlign: 'top'}}>
                            {row?.gender|| '-'}
                          </TableCellStyled>
                          
                          <TableCellStyled size="small" align="left" sx={{verticalAlign: 'top'}}>
                            {row?.assign_doctor|| '-'}
                          </TableCellStyled>

                          <TableCellStyled size="small" align="left" sx={{verticalAlign: 'top'}}>
                            {row?.room_no|| '-'}
                          </TableCellStyled>
                          
                          <TableCellStyled size="small" align="left" sx={{verticalAlign: 'top'}}>
                            {row?.support_staff_name|| '-'}
                          </TableCellStyled>
                          

                          <TableCellStyled size="small" align="left" sx={{verticalAlign: 'top'}}>
                            {row?.session_name || '-'}
                          </TableCellStyled>

                          <TableCellStyled size="small" align="left" sx={{verticalAlign: 'top'}}>
                            {row?.therapist_room || '-'}
                          </TableCellStyled>
                          
                          <TableCellStyled size="small" align="left" sx={{verticalAlign: 'top'}}>
                            {row?.session_time ? moment(row?.session_time).format("MMM DD, YYYY hh:mm A") : '-'}
                          </TableCellStyled>

                          <TableCellStyled size="small" align="left" sx={{verticalAlign: 'top'}}>
                            {row?.session_notes ? <div dangerouslySetInnerHTML={{__html: row?.session_notes}}></div> : '-'}
                          </TableCellStyled>

                          <TableCellStyled size="small" align="left" sx={{verticalAlign: 'top'}}>
                          {row?.notes_recommendation ? <div dangerouslySetInnerHTML={{__html: row?.notes_recommendation}}></div> : '-'}
                          </TableCellStyled>

      
                        </TableRowStyled>
                      </React.Fragment>
                    );
                  })}
              </>
            }
          </TableBody>
        </Table>
      </TableContainer>
      {
        loading &&
        <div className='text-center mt-5'><CircularProgress size={35} sx={{'color': '#74613C'}}/></div>
      }

      {!!pagination && !loading && data?.length>0 && (
        <div className="m-2 my-2">
          <TablePaginationStyled
            disabled={loading}
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={totalCount || 0}
            rowsPerPage={rowsPerPage || 10}
            page={currentPage || 0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            SelectProps={{
              IconComponent: arrowDownIcon,
            }}
        />
        </div>
      )}
    </Box>
  );
};

RecommendationsTable.propTypes = {
  columns: PropTypes.array.isRequired,
  defaultSortField: PropTypes.string,
  rowsPerPageOptions: PropTypes.array,
};

export default RecommendationsTable;
